import Vue from 'vue';
import ItemDetailsTemplateService from '@/services/api/item-details-template.service';
import {RootState} from '@/store/store';
import {Module} from 'vuex';
import {ItemDetailsTemplate} from '@/interfaces/item-details-template.inteface';

export const mutations = {
    SET_TEMPLATES(state: any, response: ItemDetailsTemplateResponse) {
        Vue.set(state, 'itemDetailsTemplates', response.itemDetailsTemplates);
    },
    CREATE_TEMPLATE(state: any, {itemDetailsTemplate}: { itemDetailsTemplate: ItemDetailsTemplate }) {
        Vue.set(state, 'itemDetailsTemplates', [...state.itemDetailsTemplates, itemDetailsTemplate]);
    },
    updateTemplate(state: any, {itemDetailsTemplate}: { itemDetailsTemplate: ItemDetailsTemplate }) {
        Vue.set(
            state,
            'itemDetailsTemplates',
            state.itemDetailsTemplates.map((u: ItemDetailsTemplate) => u.uuid === itemDetailsTemplate.uuid ? {...u, ...itemDetailsTemplate} : u)
        );
    },
    DELETE_TEMPLATE(state: any, {itemDetailsTemplate}: { itemDetailsTemplate: ItemDetailsTemplate }) {
        Vue.set(state, 'itemDetailsTemplates', state.itemDetailsTemplates.filter((u: ItemDetailsTemplate) => u.uuid !== itemDetailsTemplate.uuid));
    },
    setItemDetailsTemplateDialogVisibility(state: any, isVisible: boolean) {
      Vue.set(state, 'itemDetailsTemplatesDialogVisible', isVisible);
    }
};

export const actions = {
    async fetchTemplates({commit, state}: any) {
        commit('LOADING_START', null, {root: true});
        try {
            const response: ItemDetailsTemplateResponse = await ItemDetailsTemplateService.getAll();
            commit('LOADING_FINISH', null, {root: true});
            commit('SET_TEMPLATES', {
              itemDetailsTemplates: response,
            });
        } catch (e) {
            commit('LOADING_FINISH', null, {root: true});
            console.log('error', e);
        }
    },
    async createTemplate(
        {commit, dispatch}: any,
        {itemDetailsTemplate, successAction, successPayload}: { itemDetailsTemplate: ItemDetailsTemplate, successAction: string, successPayload: any }) {
        commit('LOADING_START', null, {root: true});
        try {
            const response = await ItemDetailsTemplateService.create(itemDetailsTemplate);
            commit('CREATE_TEMPLATE', {itemDetailsTemplate: response});
            dispatch('SET_ALERT_MESSAGE', 'Item Details Template created', {root: true});
            if (successAction) dispatch(successAction, successPayload);
        } catch (e) {
            console.log(e);
            dispatch('SET_ALERT_MESSAGE', 'Creating itemDetailsTemplate failed', {root: true});
        } finally {
            commit('LOADING_FINISH', null, {root: true});
        }
    },
    async updateTemplate(
        {commit, dispatch}: any,
        {itemDetailsTemplate, successAction, successPayload}: { itemDetailsTemplate: ItemDetailsTemplate, successAction: string, successPayload: any }) {
        commit('LOADING_START', null, {root: true});
        try {
            const response = await ItemDetailsTemplateService.update(itemDetailsTemplate);
            commit('updateTemplate', {itemDetailsTemplate: response});
            if (successAction) dispatch(successAction, successPayload);
            dispatch('SET_ALERT_MESSAGE', 'Item Details Template updated', {root: true});
        } catch (e) {
            dispatch('SET_ALERT_MESSAGE', 'Updating itemDetailsTemplate failed', {root: true});
            console.log(e);
        } finally {
            commit('LOADING_FINISH', null, {root: true});
        }
    },
    async deleteWithConfirmation({commit}: any, {itemDetailsTemplate, successAction}: { itemDetailsTemplate: ItemDetailsTemplate, successAction: string }) {
        commit('SHOW_CONFIRMATION', {
            message: `Delete ${itemDetailsTemplate.name}?`,
            action: 'templates/delete',
            payload: {itemDetailsTemplate, successAction}
        }, {root: true});
    },
    async delete({commit, dispatch}: any, {itemDetailsTemplate, successAction}: { itemDetailsTemplate: ItemDetailsTemplate, successAction: string }) {
        commit('LOADING_START', null, {root: true});
        try {
            if (!itemDetailsTemplate.uuid) return dispatch('SET_ALERT_MESSAGE', `Can't delete a itemDetailsTemplate without a uuid`, {root: true});
            await ItemDetailsTemplateService.delete(itemDetailsTemplate.uuid);
            await commit('DELETE_TEMPLATE', {itemDetailsTemplate});
            dispatch('SET_ALERT_MESSAGE', 'Item Details Template deleted', {root: true});
            if (successAction) dispatch(successAction);
        } catch (e) {
            console.log(e);
            dispatch('SET_ALERT_MESSAGE', 'Deleting itemDetailsTemplate failed', {root: true});
        } finally {
            commit('LOADING_FINISH', null, {root: true});
        }
    },
    openItemDetailsTemplateialog({commit}: any) {
      commit('setItemDetailsTemplateDialogVisibility', true);
    },
    closeItemDetailsTemplateDialog({commit}: any) {
      commit('setItemDetailsTemplateDialogVisibility', false);
    },
};

export interface TemplatesState {
    itemDetailsTemplates: ItemDetailsTemplate[],
    itemDetailsTemplatesDialogVisible: boolean,
}

export interface ItemDetailsTemplateResponse {
  itemDetailsTemplates: ItemDetailsTemplate[],
}

export const templatesState: TemplatesState = {
    itemDetailsTemplates: [],
    itemDetailsTemplatesDialogVisible: false,
};

export const templatesStoreModule: Module<TemplatesState, RootState> = {
    namespaced: true,
    state: templatesState,
    actions,
    mutations,
};
